import MenuSelect from "../sudokit/components/SudoSelect/MenuSelect";
import React, { useEffect, useState } from "react";
import Auth from "../Auth";
import { SudoButton } from "../sudokit/components/SudoButton";

/** Personal runtime preference; other accounts are unaffected. */
export default function ChatControls() {
  const [runtimes, setRuntimes] = useState<Array<{ value: string; label: string; subLabel?: string }>>([]);
  const [runtime, setRuntime] = useState("");
  const [email, setEmail] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  useEffect(() => {
    let active = true;
    Auth.fetchWithIdToken("/api/admin/chat-controls/get", {}).then(result => {
      if (!active) return;
      if (!result.success) throw new Error(result.message || "Unable to load chat controls");
      setRuntimes(result.runtimes); setRuntime(result.runtime ?? ""); setEmail(result.email ?? ""); setLoaded(true);
    }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, []);
  async function save() {
    setBusy(true); setError(""); setNotice("");
    try {
      const result = await Auth.fetchWithIdToken("/api/admin/chat-controls/save", { runtime: runtime || null });
      if (!result.success) throw new Error(result.message || "Unable to save chat controls");
      setNotice(runtime ? "Saved. Your next chat turn will use this runtime." : "Override removed. Your chats will use normal runtime selection.");
    } catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    finally { setBusy(false); }
  }
  return <div className="w-full text-left mx-auto max-w-4xl px-4 pt-6 pb-20 text-app-grey-0 sm:px-6 lg:px-8">
    <h1 className="my-2 text-3xl font-semibold">Chat Controls</h1>
    <p>Choose the chat runtime for your signed-in admin account{email ? ` (${email})` : ""}.</p>
    {error && <p role="alert" className="my-4 text-app-danger-color">{error}</p>}
    {notice && <p role="status" className="my-4 text-app-primary-cta-high-contrast">{notice}</p>}
    {!loaded ? (!error && <p>Loading chat controls…</p>) : <section className="my-6 space-y-4 rounded-xl border border-app-menu-color-hover bg-app-menu-color p-6 shadow-card">
      <div className="space-y-2"><p className="font-medium">Chat runtime</p>
        <MenuSelect menuType="radiobutton" label="Chat runtime" variant="secondary" value={runtime || "normal"} disabled={busy}
          onChange={(value: string) => { setRuntime(value === "normal" ? "" : value); setNotice(""); }}
          options={[{ value: "normal", label: "Use normal runtime assignment" }, ...runtimes]} />
      </div>
      <p className="text-sm text-app-grey-1">Applies to your next turn in new and existing chats, in Chat and Write modes. This selects both the runtime behavior and its model for your account. Running turns, queued work, and saved proposals keep their original runtime. Rollback protections still apply. Clearing this override restores normal assignments.</p>
      <SudoButton disabled={busy} onClick={save}>{busy ? "Saving…" : "Save chat runtime"}</SudoButton>
    </section>}
  </div>;
}
